<div class="archive-page">
  <mat-drawer-container class="archive-shell" [hasBackdrop]="mode == 'over'">
    <mat-drawer #drawer [mode]="mode" [opened]="isOpenedFilter" class="archive-drawer">
      <app-filter
        (searchFilter)="searchArticles($event)"
        [searchText]="searchText"
        [restoredFilters]="restoredFormValues"
        [restoredYearFormat]="restoredYearFormat">
      </app-filter>
    </mat-drawer>
    <mat-drawer-content>
      <div class="archive-main">
        <div class="container-xxl archive-results">
        <header class="archive-head">
          <div>
            <h1>Archivio storico</h1>
            <p>Le schede del catalogo della Misericordia di Borgo San Lorenzo.</p>
          </div>
          @if (isTogglerButton) {
            <div class="filter-toolbar">
              <button class="filter-toggle" type="button" (click)="drawer.toggle(); scrollToTopOfPage()">
                <i class="bi bi-funnel" aria-hidden="true"></i>
                @if (!drawer.opened) {
                  <span>Filtri</span>
                } @else {
                  <span>Chiudi filtri</span>
                }
              </button>
              @if (activeFilterLabels.length) {
                <ul class="active-filters" aria-label="Filtri attivi">
                  @for (label of activeFilterLabels; track label) {
                    <li>{{ label }}</li>
                  }
                </ul>
              }
            </div>
          }
        </header>

        <div class="archive-stats">
          <span><strong>{{ totalResults }}</strong> {{ totalResults === 1 ? 'risultato' : 'risultati' }}</span>
          <span>{{ totalPages }} {{ totalPages === 1 ? 'pagina' : 'pagine' }}</span>
        </div>

        @if (articles.length > 0) {
          <ng-container *ngTemplateOutlet="pagesNav; context: { label: 'Paginazione, in alto' }"></ng-container>

          <app-card-archive [articlesH]="articles" [type]="1" (navigate)="navigate($event)"></app-card-archive>

          <ng-container *ngTemplateOutlet="pagesNav; context: { label: 'Paginazione, in basso' }"></ng-container>
        } @else {
          <p class="archive-empty">La ricerca non ha prodotto risultati.</p>
        }
        </div>
      </div>

      <ng-template #pagesNav let-label="label">
        <nav class="archive-pages" [attr.aria-label]="label">
          <div class="page-controls">
            <button type="button" aria-label="Pagina precedente" [disabled]="currentPageIndex === 1"
              (click)="goToPage(currentPageIndex - 1)">
              <i class="bi bi-chevron-left" aria-hidden="true"></i>
            </button>
            <div class="page-list" (scroll)="onPageListScroll($event)">
              @for (token of pageTokens; track $index) {
                @if (token === 'ellipsis') {
                  <span class="page-gap" aria-hidden="true">…</span>
                } @else {
                  <button type="button" [class.is-active]="currentPageIndex === token"
                    [attr.aria-current]="currentPageIndex === token ? 'page' : null"
                    (click)="goToPage(token)">{{ token }}</button>
                }
              }
            </div>
            <button type="button" aria-label="Pagina successiva" [disabled]="currentPageIndex === totalPages"
              (click)="goToPage(currentPageIndex + 1)">
              <i class="bi bi-chevron-right" aria-hidden="true"></i>
            </button>
          </div>
          <label class="page-size">
            <span class="page-size-label">
              <span>Elementi</span>
              <span>per pagina</span>
            </span>
            <select (change)="setItemsPerPage($event)">
              @for (size of pageSizeOptions; track size) {
                <option [value]="size" [selected]="size === itemsPerPage">{{ size }}</option>
              }
            </select>
          </label>
        </nav>
      </ng-template>
    </mat-drawer-content>
  </mat-drawer-container>
</div>
